import styled from "styled-components";
export const MenuContent = styled.div `
    position: relative;
    margin: 1%;
    display: flex;
    justify-content: flex-end;
`;
